<template>
    <div>
        <app-bar :backBtn="{ visible: false }" :navTab="false" class="px-5">
            <template #title> Branches </template>
            <template #actionBtns>
                <v-btn :to="navigation('to', ['add'])" color="primary" class="ml-auto"><v-icon left> mdi-plus </v-icon> Add Branch</v-btn>
            </template>
        </app-bar>

        <v-container fluid class="pa-10">
            <DataTable module="branches" :customFilters="customFilters" />
        </v-container>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import DataTable from '@/components/Merchant/DataTable.vue';

export default {
    name: 'Branches',
    components: {
        AppBar,
        DataTable
    },
    data() {
        return {
            customFilters: {
                classification: { show: true, disabled: true, value: 'BRANCH' }
            }
        };
    }
};
</script>
